import type { SVGProps } from 'react';

interface ClockIconProps {
  title?: string;
  titleId?: string;
  desc?: string;
  descId?: string;
}
export const ClockIcon = ({
  title,
  titleId,
  desc,
  descId,
  ...props
}: SVGProps<SVGSVGElement> & ClockIconProps) => (
  <svg
    {...props}
    aria-labelledby={titleId}
    fill="none"
    height="1em"
    role="img"
    viewBox="0 0 16 16"
    width="1em"
    xmlns="http://www.w3.org/2000/svg"
  >
    <title id={titleId}>{title}</title>
    <path
      d="M9.95 9.4h-2.4a.45.45 0 0 1-.45-.45v-3.6a.45.45 0 0 1 .9 0V8.5h1.95a.45.45 0 0 1 0 .9M8 2.5a6 6 0 1 0 .001 12.001A6 6 0 0 0 8 2.5"
      fill="currentColor"
    />
  </svg>
);
